import { EventEmitter } from '@angular/core';
import { TimeInputComponent } from '../time-input/time-input.component';
import { AchievementService } from 'app/shared/services/achievement.service';
var ReminderBoxComponent = (function () {
    function ReminderBoxComponent(achievementService) {
        this.achievementService = achievementService;
        this.editing = false;
        this.canEdit = true;
        this.canAdd = false;
        this.startEditing = new EventEmitter();
        this.doneEditing = new EventEmitter();
        this.delete = new EventEmitter();
        this.disabled = false;
        this.editingClass = false;
    }
    Object.defineProperty(ReminderBoxComponent.prototype, "reminder", {
        get: function () {
            return this.reminderValue;
        },
        set: function (val) {
            this.reminderValue = val;
            this.disabled = !this.reminder.isActive;
        },
        enumerable: true,
        configurable: true
    });
    ReminderBoxComponent.prototype.ngOnInit = function () {
        if (this.canAdd) {
            this.editing = true;
        }
    };
    ReminderBoxComponent.prototype.toggleActive = function (e) {
        this.disabled = !e.checked;
        this.reminder.isActive = e.checked;
        this.doneEditing.emit(this);
    };
    ReminderBoxComponent.prototype.reset = function () {
        this.timeinput.reset();
    };
    ReminderBoxComponent.prototype.save = function () {
        if (this.evaluate()) {
            this.editing = false;
            this.editingClass = false;
            this.doneEditing.emit(this);
        }
    };
    ReminderBoxComponent.prototype.saveNew = function () {
        if (this.evaluate()) {
            this.doneEditing.emit(this);
        }
    };
    ReminderBoxComponent.prototype.evaluate = function () {
        // only enable save if at least one day is enabled and time is set
        if (this.reminder.time.hours == undefined || this.reminder.time.minutes == undefined) {
            this.reminder.time.hours = this.reminder.time.hours || 0;
            this.reminder.time.minutes = this.reminder.time.minutes || 0;
        }
        var setDays = false;
        for (var _i = 0, _a = Object.keys(this.reminder.repeatOnDays); _i < _a.length; _i++) {
            var day = _a[_i];
            setDays = this.reminder.repeatOnDays[day] || setDays;
        }
        if (!setDays) {
            return false;
        }
        return true;
    };
    ReminderBoxComponent.prototype.remove = function () {
        this.delete.emit(this);
    };
    ReminderBoxComponent.prototype.edit = function () {
        if (this.canEdit) {
            this.editing = true;
            this.editingClass = true;
            this.startEditing.emit(this);
        }
    };
    return ReminderBoxComponent;
}());
export { ReminderBoxComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/reminder-box/reminder-box.component.ts.pre-build-optimizer.js